<template>
  <div>
      <h1>news</h1>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>